module.exports = __webpack_public_path__ + "img/trash.caa5ed5c.svg";